import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import styles from "./DoctorInfoPop.module.scss";
import { getDoctorProfile } from "../../../../api/apiHandler";
import queryString from "query-string";
const PatientInfoEditPop = ({
  patiendInfo,
  setPatientInfo,
  patientData,
  tempPrescription,
  mainPrescription,
  typepres,
}) => {
  const handlePatientInfo = () => setPatientInfo(!patiendInfo);
  const [patientDataObj, setPatientDataObj] = useState();
  const [profileDetails, setProfileDetails] = useState(null);
  console.log("patientData==>", patientData);
  const params = queryString.parse(window.location.search);

  useEffect(() => {
    setPatientDataObj(patientData);
  }, [patientData]);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        getDoctorProfile({}).then((response) => {
          response = JSON.parse(response);
          if (response.code == process.env.REACT_APP_SUCCESS) {
            console.log(response);
            setProfileDetails(response.data);
          }
        });
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfile();
  }, []);

  console.log(profileDetails, "profileDetails");

  const today = new Date().toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  function formatDate(presDate) {
    const dateObj = new Date(presDate);
    return `${String(dateObj.getDate()).padStart(2, "0")}/${String(
      dateObj.getMonth() + 1
    ).padStart(2, "0")}/${dateObj.getFullYear()}`;
  }
  let presdate = null;

  if (typepres == "prescription" && mainPrescription?.length > 0) {
    presdate = formatDate(mainPrescription?.[0]?.createdAt);
  } else if (typepres == "temp-prescription" && tempPrescription?.length > 0) {
    presdate = formatDate(tempPrescription?.[0]?.createdAt);
  }
  console.log("presdate", presdate);
  console.log("tempPrescription", tempPrescription);
  const userRole = localStorage.getItem("user_login_type_role");
  return (
    <>
      <Modal
        show={patiendInfo}
        onHide={handlePatientInfo}
        backdrop="static"
        keyboard={false}
        centered
        size="xl"
        className={`${styles.PatientInfoPop} PatientInfoPop`}
        scrollable="true"
      >
        <Modal.Header
          className={`${styles.header} position-relative`}
          closeButton
        >
          {
            <>
              {" "}
              <Modal.Title className="font_30 font_500 text-blue text-download d-flex align-items-center gap-2 mb-0">
                {/* {userRole == "1"
                  ? "Patient Info"
                  : userRole == "4" || params?.isPriestMeeting == "true"
                  ? "Priest Info"
                  : "Doctor Info"} */}
                Patient Info
              </Modal.Title>
              <div className="flex items-center gap-10 ms-auto text-blue">
                Date: {today}
              </div>{" "}
            </>
          }
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="">
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  First Name:
                </label>
                <input
                  readOnly
                  value={patientDataObj?.first_name || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  Last Name:
                </label>
                <input
                  readOnly
                  value={patientDataObj?.last_name || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  Address:
                </label>
                <input
                  readOnly
                  value={patientDataObj?.address || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  City:
                </label>
                <input
                  readOnly
                  value={patientDataObj?.city || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  State:
                </label>
                <input
                  readOnly
                  value={patientDataObj?.state || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  Country:
                </label>
                <input
                  readOnly
                  value={patientDataObj?.country || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  Phone:
                </label>
                <input
                  readOnly
                  value={patientDataObj?.phone_no || ""}
                  type="text"
                  className="form-control "
                />
              </Col>
              <Col md="6" className="my-2">
                <label htmlFor="" className="form-label">
                  Email:
                </label>
                <input
                  readOnly
                  value={patientDataObj?.email || ""}
                  type="text"
                  className="form-control "
                />
              </Col>

              {typepres && (
                <Col
                  md="6"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                  className="flex"
                >
                  <p
                    className="font_30 font_500 text-blue text-download d-flex align-items-center gap-2 mb-0 "
                    style={{
                      color: "red",
                      marginRight: "44px",
                      fontSize: "24px",
                    }}
                  >
                    {userRole == "4" || params.isPriestMeeting == "true"
                      ? "Report"
                      : "Prescription"}{" "}
                    Date: {presdate ? presdate : "N/A"}
                  </p>
                </Col>
              )}
            </Row>
            <Row className=""></Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PatientInfoEditPop;
